import { toast } from 'react-toastify';

export const MAP_LAYER_ZOOM_THRESHOLDS: Record<string, number> = {
  Pipeline: 13,
  Parcel: 16,
  'Oil/Gas': 13,
  Soil: 16,
  MSD: 16,
  NPL: 10,
  Contour: 13,
};

export const MAP_LAYER_ZOOM_TOAST_MESSAGE = 'Zoom in to show more information.';

/** Layer cannot be enabled until map zoom is strictly greater than this threshold. */
export const isMapLayerZoomTooLow = (
  layer: string,
  zoom: number | undefined | null
): boolean => {
  if (zoom == null || Number.isNaN(zoom)) {
    return true;
  }
  const minZoom = MAP_LAYER_ZOOM_THRESHOLDS[layer];
  if (minZoom == null) {
    return false;
  }
  return zoom <= minZoom;
};

export const getMapLayerZoomMessage = (): string => MAP_LAYER_ZOOM_TOAST_MESSAGE;

export const notifyMapLayerZoomBlocked = (): void => {
  toast.info(MAP_LAYER_ZOOM_TOAST_MESSAGE, {
    toastId: 'map-layer-zoom-info',
  });
};

/** Returns true when the click was blocked and an alert was shown. */
export const blockMapLayerClickWhenZoomTooLow = (
  layer: string,
  zoom: number | undefined | null,
  event: { preventDefault: () => void; stopPropagation: () => void }
): boolean => {
  if (!isMapLayerZoomTooLow(layer, zoom)) {
    return false;
  }
  event.preventDefault();
  event.stopPropagation();
  notifyMapLayerZoomBlocked();
  return true;
};
